var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRighteArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon / Back"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Back / Button",
    d: "M1.53429 11.9063C1.65827 11.9063 1.78226 11.8375 1.90624 11.7688L6.80359 6.95529C7.05156 6.68023 7.11355 6.19888 6.86558 5.92383C6.86558 5.92383 6.86558 5.92383 6.80359 5.85506L1.90624 1.04158C1.65827 0.835287 1.34831 0.835287 1.10035 1.11034C1.10035 1.11034 1.10035 1.17911 1.03835 1.17911C0.852379 1.45416 0.852378 1.93551 1.10035 2.1418L5.56375 6.40518L1.22433 10.6685C0.976362 10.9436 0.914371 11.3562 1.16234 11.6312C1.22433 11.8375 1.41031 11.9063 1.53429 11.9063Z",
    fill: "currentColor"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRighteArrow);
export default __webpack_public_path__ + "static/media/righte_arrow.a85849f7e084d05d56c62c6367c71868.svg";
export { ForwardRef as ReactComponent };